<template>
    <main class="backoffice-v2" role="main">
        <portal to="ariane">
            <div class="tbv2-page-title">{{ $t('menu.companies.backoffice_infos') }}</div>
        </portal>

        <header class="backoffice-hero">
            <h1 class="backoffice-hero-title">{{ $t('backoffice_infos.title') }}</h1>
            <p class="backoffice-hero-sub">{{ $t('menu.companies.backoffice_subtitle') }}</p>
        </header>

        <div v-if="isLoading" class="backoffice-state">
            <BmvLoader :active="true" />
        </div>

        <div v-else class="backoffice-stack">
            <BackofficeSummary :forms="forms" :formTypes="formTypes" />
            <BackofficeFormTypes :forms="forms" :formTypes="formTypes" />
            <BackofficeStatuses :forms="forms" />
            <BackofficeRaci :forms="forms" />
            <BackofficeDeployments :forms="forms" />
            <BackofficeFields :forms="forms" />
        </div>
    </main>
</template>

<script>
import { mapActions } from 'vuex'
import BackofficeSummary from '@/components/Model/Backoffice/BackofficeSummary'
import BackofficeFormTypes from '@/components/Model/Backoffice/BackofficeFormTypes'
import BackofficeStatuses from '@/components/Model/Backoffice/BackofficeStatuses'
import BackofficeRaci from '@/components/Model/Backoffice/BackofficeRaci'
import BackofficeDeployments from '@/components/Model/Backoffice/BackofficeDeployments'
import BackofficeFields from '@/components/Model/Backoffice/BackofficeFields'
import BmvLoader from '@/components/UI/v2/BmvLoader.vue'

export default {
    name: 'BackofficeInfos',
    components: {
        BackofficeSummary,
        BackofficeFormTypes,
        BackofficeStatuses,
        BackofficeRaci,
        BackofficeDeployments,
        BackofficeFields,
        BmvLoader
    },
    data() {
        return {
            isLoading: true,
            forms: [],
            formTypes: []
        }
    },
    created() {
        this.loadData()
    },
    methods: {
        ...mapActions('form', ['getBackofficeOverview']),
        async loadData() {
            this.isLoading = true
            try {
                const data = await this.getBackofficeOverview()
                this.formTypes = data.form_types || []
                this.forms = data.forms || []
                this.isLoading = false
            } catch (error) {
                this.isLoading = false
                this.$store.dispatch('dispatchError', error)
            }
        }
    }
}
</script>

<style scoped>
.backoffice-v2 {
    width: 100%;
    padding: 24px 32px 48px;
    font-family: var(--v2-font-sans);
    color: var(--v2-text-2);
}

.tbv2-page-title {
    font-size: 0.95rem;
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-1);
    letter-spacing: -0.005em;
}

.backoffice-hero {
    margin-bottom: var(--v2-space-5);
}

.backoffice-hero-title {
    margin: 0 0 6px;
    font-size: 1.75rem;
    font-weight: var(--v2-font-weight-bold);
    color: var(--v2-text-1);
    letter-spacing: -0.02em;
    line-height: 1.15;
}

.backoffice-hero-sub {
    margin: 0;
    font-size: var(--v2-text-sm-size);
    color: var(--v2-text-3);
    line-height: 1.5;
    max-width: 820px;
}

.backoffice-state {
    position: relative;
    min-height: 200px;
    background: var(--v2-surface-0);
    border: 1px solid var(--v2-border);
    border-radius: var(--v2-radius-lg);
}

.backoffice-stack {
    display: flex;
    flex-direction: column;
    gap: var(--v2-space-4);
}

@media (max-width: 900px) {
    .backoffice-v2 {
        padding: 16px 18px 32px;
    }

    .backoffice-hero-title {
        font-size: 1.375rem;
    }
}
</style>
